export default __webpack_public_path__ + "static/logo_soc3@2x-6763c154223353f97a2928ba23bce000.png";